// Libs
import ApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
// Types
import { ChartSetFour } from "../Libs/Types/ChartTypes";
// Utils
import {
  chartColors,
  CHART_AXIS_FALLBACK,
  chartHeight,
} from "../Libs/Utils/utils";
// UI-Components
import ChartFallBack from "../UI-Components/ChartFallback";

export default function DoughnutChart({
  chartData,
  dataKey,
}: {
  chartData: ChartSetFour["DoughnutChart"];
  dataKey: string;
}) {
  const option: ApexOptions = {
    chart: {
      fontFamily: "Poppins",
      toolbar: {
        show: true,
      },
    },
    legend: {
      show: false,
    },
    fill: {
      colors: chartColors,
    },
    dataLabels: {
      style: {
        fontSize: "8px",
      },
    },
    title: {
      style: { fontSize: "14px", fontWeight: "900" },
      text:
        chartData !== undefined
          ? chartData["title"]
          : CHART_AXIS_FALLBACK["title"],
      align: "left",
    },
    xaxis: {
      labels: {
        style: {
          fontSize: "8px",
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: "8px",
        },
      },
    },
    labels:
      chartData !== undefined ? chartData["data"][0]["labels"] : undefined,
  };

  const series: any =
    chartData !== undefined &&
    Array.isArray(chartData["data"][0]["data"]) === true
      ? chartData["data"][0]["data"]
      : undefined;

  return (
    <div className="my-2 chartWrp border-1 rounded-lg w-full p-2">
      {series !== undefined && option.labels !== undefined ? (
        <ApexChart
          type="donut"
          options={option}
          series={series}
          height={chartHeight}
          width={"100%"}
          key={dataKey}
        />
      ) : (
        <ChartFallBack />
      )}
    </div>
  );
}
